<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>升学列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="赴日时间" label-width="80px">
          <el-select v-model="query.abroadPlan" filterable clearable placeholder="请选择" @change="selList()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="exportClick()">导出</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>升学列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
        >
          <!-- 报考时信息 -->
          <el-table-column label="报考时" align="center" :width="800">
            <el-table-column prop="realName" label="姓名" :width="100" fixed="left"></el-table-column>
            <el-table-column prop="sex" label="性别" :width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.sex ? '男' : '女' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="eduBack" label="学历" :width="100"></el-table-column>
            <el-table-column prop="applyArtsScience" label="文科/理科" :width="100"></el-table-column>
            <el-table-column prop="applyMajor" label="专业" :width="150"></el-table-column>
            <el-table-column prop="schoolName" label="出身校" :width="150"></el-table-column>
            <el-table-column prop="applyJapanese" label="日语（报考时）" :width="120"></el-table-column>
            <el-table-column prop="applyEnglish" label="英语（报考时）" :width="120"></el-table-column>
          </el-table-column>
          
          <!-- 合格时信息 -->
          <el-table-column label="合格时" align="center" :width="900">
            <el-table-column prop="qualifiedTime" label="合格时间" :width="120"></el-table-column>
            <el-table-column prop="qualifiedArtsScience" label="文科/理科" :width="100"></el-table-column>
            <el-table-column prop="examScore" label="留考成绩" :width="120"></el-table-column>
            <el-table-column prop="qualifiedJapanese" label="日语" :width="120"></el-table-column>
            <el-table-column prop="qualifiedEnglish" label="英语" :width="120"></el-table-column>
            <el-table-column prop="qualifiedSchools" label="合格学校及专业" :width="200">
              <template slot-scope="scope">
                <span :title="scope.row.qualifiedSchools">{{ scope.row.qualifiedSchools || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="enrolledSchool" label="入学学校" :width="150"></el-table-column>
            <el-table-column prop="enrolledMajor" label="入学专业" :width="150"></el-table-column>
          </el-table-column>

          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-mingye="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="showLimitedOpMingye(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.studentID"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid = scope.row.studentID"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditMingye(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :size-page="pageSize"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog title="编辑升学信息" :visible.sync="dialogVisible" width="900px">
      <el-form :model="form" ref="form" label-width="120px">
        <el-form-item label="升学阶段" prop="stage" :rules="[{ required: true, message: '请选择升学阶段' }]">
          <el-radio-group v-model="form.stage">
            <el-radio :label="1">赴日前</el-radio>
            <el-radio :label="2">升学时</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <!-- 赴日前 -->
        <template v-if="form.stage == 1">
          <el-divider content-position="left">赴日前信息</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="学历">
                <el-select v-model="form.eduBack" placeholder="请选择学历" filterable style="width: 100%;">
                  <el-option
                    v-for="item in edubacklist"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="出身校">
                <el-input v-model="form.schoolName" placeholder="请输入出身校"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="日语（赴日前）">
                <el-input v-model="form.japanese" placeholder="请输入赴日前日语水平"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="英语（赴日前）">
                <el-input v-model="form.english" placeholder="请输入赴日前英语水平"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        
        <!-- 升学时 -->
        <template v-if="form.stage == 2">
          <el-divider content-position="left">升学时信息</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="留考成绩">
                <el-input v-model="form.examScore" placeholder="请输入留考成绩"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="专业">
                <el-input v-model="form.major" placeholder="请输入专业"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="文理">
                <el-select v-model="form.artsScience" placeholder="请选择" style="width: 100%;">
                  <el-option label="文科" value="文科"></el-option>
                  <el-option label="理科" value="理科"></el-option>
                  <el-option label="艺术" value="艺术"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="日语（升学时）">
                <el-input v-model="form.japaneseEnroll" placeholder="请输入升学时日语成绩"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="英语（升学时）">
            <el-input v-model="form.englishEnroll" placeholder="请输入升学时英语成绩"></el-input>
          </el-form-item>
          <el-form-item label="合格时间">
            <el-date-picker
              v-model="form.qualifiedTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择合格时间"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="合格学校及专业">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.qualifiedSchools"
              placeholder="请输入合格学校及专业，多个学校请用逗号分隔或JSON格式"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="入学学校">
                <el-input v-model="form.enrolledSchool" placeholder="请输入入学学校"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="入学专业">
                <el-input v-model="form.enrolledMajor" placeholder="请输入入学专业"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        
        <el-form-item>
          <el-button type="primary" :loading="submiting" @click="submitForm">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <!-- 升学列表：可分配留学、日语，不显示鸣野（当前即鸣野资源） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="true"
      :show-mingye="false"
      name-label="资源名称"
      empty-message="请选择分配给留学或日语"
      @success="getList"
    />
    <StudentShow :stuid="showstuid" v-on:setzero="showstuid = 0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
export default {
  components: { StudentShow, OtherDeptFollow, FollowDetailDialog, AssignResourceDialog },
  data() {
    return {
      userIsAdmain: user.isAdmin(),
      userIsAdviser: user.isAdviser(),
      query: {},
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      edubacklist: url.getEduBack(),
      showstuid: 0,
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
      assignDialogVisible: false,
      assignForm: {
        studentID: null,
        realName: '',
        isJap: false,
        resourceTypes: [],
        myAdviserID: null,
        myMarketID: null
      },
      adviserlist: [],
      marketlist: [],
      planList: url.getAbroadYear(), // 赴日时间（与其它鸣野列表一致）
    };
  },
  methods: {
    canEditMingye(row) {
      return user.canEditMingye(row);
    },
    isMarketingOnlyMingye(row) {
      return user.isMarketingOnlyMingye(row);
    },
    isNoAdviserMingye(row) {
      return user.isNoAdviserMingye(row);
    },
    showLimitedOpMingye(row) {
      return user.showLimitedOpMingye(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getMingye("getlist_stage");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    editClick: function(row) {
      // 与留学 Common 一致：不请求接口，直接用列表行整表回填
      this.form = Object.assign({}, row);
      if (this.form.stage == null) this.form.stage = 1;
      this.dialogVisible = true;
    },
    submitForm: function() {
      var _this = this;
      var link = url.getMingye("update_stage");
      this.submiting = true;
      $.post(link, _this.form, (res) => {
        _this.submiting = false;
        if (res.status) {
          _this.dialogVisible = false;
          _this.getList();
          _this.$message({
            type: "success",
            message: res.msg,
          });
        } else {
          _this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    exportClick: function() {
      var _this = this;
      var params = _this.query;
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getMingye("export_stage") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.studentID != null || row.id != null) ? { ...row, id: row.studentID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    assignClick(row) {
      if (!row) return;
      this.assignForm = {
        studentID: row.studentID || row.id,
        realName: row.realName || '',
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: true,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: row.jpMarketID || null,
        myAdviserID: row.myAdviserID || null,
        myMarketID: row.myMarketID || null
      };
      this.assignDialogVisible = true;
    },
  },
  mounted() {
    this.getList();
    var _this = this;
    $.get(url.getStu("getenableusers"), {}, (data) => {
      var list = data || [];
      _this.marketlist = list;
      _this.adviserlist = list;
    });
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>

